module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 20\"><path fill=\"#7A8291\" d=\"M214.995361,20.9536133 L217.981445,20.9536133 L219.972168,16.972168 L219.972168,11 L214,11 L214,16.972168 L216.986084,16.972168 L214.995361,20.9536133 Z M222.958252,20.9536133 L225.944336,20.9536133 L227.935059,16.972168 L227.935059,11 L221.962891,11 L221.962891,16.972168 L224.948975,16.972168 L222.958252,20.9536133 Z\" transform=\"translate(-210 -6)\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/quote.svg
// module id = 770
// module chunks = 0